import { useContext, useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
} from '@mui/material';
import {
  AssociateApprovalStatus,
  AssociateSetupContext,
  AuthenticationContext,
  OnboardingSteps,
  useCompleteAssociateOnboardingStep,
} from '@vs-online-only-app/state';
import { CheckCircleOutlineOutlined } from '@mui/icons-material';

const AssociateApprovedModal = () => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const completeAssociateOnboardingStep = useCompleteAssociateOnboardingStep();
  const { associateSetupState } = useContext(AssociateSetupContext);
  const { user: associate } = useContext(AuthenticationContext);

  useEffect(() => {
    const isApproved =
      associate?.approvalStatus === AssociateApprovalStatus.Approved;
    const isOnLetsBeginStep =
      associateSetupState?.onboarding.current === OnboardingSteps.letsbegin;
    setOpen(isApproved && isOnLetsBeginStep);
  }, [associate?.approvalStatus, associateSetupState?.onboarding]);

  const onClose = async () => {
    setIsLoading(true);
    await completeAssociateOnboardingStep.mutateAsync({
      onboardingStep: OnboardingSteps.letsbegin,
    });
    setOpen(false);
    setIsLoading(false);
  };

  return (
    <Dialog open={open}>
      <DialogTitle>
        <Stack direction="row" gap={2} alignItems="center">
          <CheckCircleOutlineOutlined fontSize="large" />
          You've been approved
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>
          You are ready to connect with customers. Go available now to start
          claiming chats.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          fullWidth
          variant="contained"
          disabled={isLoading}
          size="large"
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            "Let's go!"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssociateApprovedModal;
